import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useMemo } from "react";

import { useThemeQuery } from "@/hooks/useThemeQuery";
import { defaultThemeTokens, mergeThemeTokens } from "@/lib/theme";
import type { ThemeTokens } from "@/lib/theme";

interface AppThemeProviderProps {
  children: React.ReactNode;
}

function buildMuiTheme(tokens: ThemeTokens) {
  return createTheme({
    palette: {
      primary: {
        main: tokens.primary,
      },
      background: {
        default: tokens.background,
      },
      text: {
        primary: tokens.text,
      },
    },
    typography: {
      fontFamily:
        '"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
  });
}

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const { data } = useThemeQuery();
  const tokens = useMemo(
    () => mergeThemeTokens(data?.tokens ?? defaultThemeTokens),
    [data?.tokens],
  );
  const theme = useMemo(() => buildMuiTheme(tokens), [tokens]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
